<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-row>
      <el-col :span="4">
        <el-input v-model="name" placeholder="请输入名称"></el-input>
      </el-col>
      <el-col :span="4">
        <el-date-picker type="datetime" placeholder="选择开始时间" v-model="sTime" style="width: 100%;"></el-date-picker>
      </el-col>
      <el-col :span="4">
        <el-date-picker type="datetime" placeholder="选择结束时间" v-model="eTime" style="width: 100%;"></el-date-picker>
      </el-col>
      <el-col :span="12">
        <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
      </el-col>
    </el-row>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'labels'
        label= '标签'
        width= '180'>
      </el-table-column>
      <el-table-column
        prop= 'msg'
        label= '信息'>
      </el-table-column>
      <el-table-column
        prop= 'addTime'
        label= '时间'
        width= '160'>
        <template slot-scope='scope'>
          {{ formatDate(scope.row.addTime) }}
        </template>
      </el-table-column>
      <el-table-column
        fixed= 'right'
        label= '等级'
        width= '100'>
        <template slot-scope='scope'>
          <el-button type='primary' size='small' v-if="scope.row.level===0">追踪</el-button>
          <el-button type='success' size='small' v-if="scope.row.level===10">调试</el-button>
          <el-button type='info' size='small' v-if="scope.row.level===20">信息</el-button>
          <el-button type='warning' size='small' v-if="scope.row.level===30">警告</el-button>
          <el-button type='danger' size='small' v-if="scope.row.level===40">错误</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import { formatDate } from '../../../util/date'
export default {
  data () {
    return {
      tableData: [],
      name: '',
      sTime: '',
      eTime: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        labels: null,
        msg: null,
        level: null,
        power: null
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0
    }
  },
  created () {
    this.query()
  },
  methods: {
    query () {
      let that = this
      requestService.get(`/log/system/manage/listPage?current=${that.current}&pageSize=${that.pageSize}&name=${that.name}&sTime=${that.sTime}&eTime=${that.eTime}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
        that.name = res.data.name
        that.sTime = res.data.sTime
        that.eTime = res.data.eTime
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/log/Index.vue